
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/expertise",
      function () {
        return require("private-next-pages/about-us/expertise.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/expertise"])
      });
    }
  